<template>
  <div class v-if="chamados.length">
    <label for="combobox" v-if="chamados[0].codigo">Selecione um chamado</label>
    <v-select
      label="label"
      class="mt-2"
      :options="chamados"
      v-model="selected"
      v-if="chamados[0].codigo"
    ></v-select>
    <div v-else class="col-md-12 mt-1 p-0">
      <div class="card absolute border-0">
        <h5 class="d-flex justify-content-center align-items-center">
          <i class="material-icons pr-2 py-3 blue color-blue">info</i> Você
          ainda não possui nenhum chamado ativo
        </h5>
      </div>
    </div>
    <transition mode="out-in">
      <div
        class="card border-0 chamado shadow-sm mt-4"
        placeholder="Selecione um chamado..."
        v-if="selected"
      >
        <small>código - {{ selected.codigo }}</small>
        <h5 class="d-flex align-items-center">
          <i class="material-icons pr-2">flag</i>
          {{ selected.itemdecatalogo }}
        </h5>
        <hr />
        <p class="p-2 mb-3 motivo pb-0" v-if="selected.tipoultimasolucao">
          {{ selected.tipoultimasolucao }} - {{ selected.ultimasolucao }}
        </p>
        <small class="pb-4 p-2">responsável: {{ selected.responsavel }}</small>
        <p class="p-2" v-if="selected.ultimasolucao">Última Solução</p>
        <small class="pb-4 p-2" v-if="selected.ultimasolucao">{{
          selected.ultimasolucao
        }}</small>
        <div class="d-flex justify-content-between px-2">
          <p>
            Aberto em
            <b>{{ formatDate(new Date(selected.dataabertura)) }}</b>
          </p>
          <p
            :class="
              selected.status == 'Cancelado' && 'Chamado Encerrado'
                ? 'danger'
                : 'success'
            "
            class="text-uppercase"
          >
            {{ selected.status }}
          </p>
        </div>
      </div>
    </transition>
  </div>
  <loading v-else />
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "MeusChamados",
  components: {
    vSelect,
  },
  data() {
    return {
      chamados: [],
      resultados: null,
      selected: null,
    };
  },
  methods: {
    formatDate(value) {
      var options = { year: "numeric", month: "numeric", day: "numeric" };
      return value.toLocaleString("pt-BR", options);
    },
    getChamados() {
      this.$http
        .get("/api/Ssm/ListarTodosChamadosSSM")
        .then((response) => {
          var value = response.data;
          value.map((e) => {
            e["label"] = e.codigo + " - " + e.itemdecatalogo;
          });

          function compare(a, b) {
            if (
              new Date(a.dataabertura).getTime() >
              new Date(b.dataabertura).getTime()
            ) {
              return -1;
            }
            if (
              new Date(a.dataabertura).getTime() <
              new Date(b.dataabertura).getTime()
            ) {
              return 1;
            }
            return 0;
          }

          value.sort(compare);

          this.chamados = value;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    this.getChamados();
  },
};
</script>

<style lang="scss" scoped></style>
